import React, { useLayoutEffect, useRef } from 'react';
import { Navigate, useLocation, useNavigationType } from 'react-router-dom';

// Browser Back means "up one level" inside a plan, not "leave the plan".
// PUSH navigation (including the explicit Plans button) remains unchanged.
export default function PlanNavigationBoundary({ children }) {
  const location = useLocation();
  const action = useNavigationType();
  const previous = useRef(null);
  const index = window.history.state?.idx;
  const last = previous.current;
  const planRoot = last?.location.pathname.match(/^\/p\/[^/]+/)?.[0];
  const goingBack = action === 'POP' && last && index < last.index;
  const target = goingBack && planRoot
    ? (last.location.state?.parentPath || planRoot)
    : null;
  const redirect = target && target !== location.pathname;

  useLayoutEffect(() => {
    if (!redirect) previous.current = { location, index };
  }, [location, index, redirect]);

  // Keep the canvas mounted during a correction. Rendering only <Navigate>
  // would tear down its loaded plan, drafts and sidebar state.
  const ancestors = last?.location.state?.hierarchyPaths?.slice(0, -1);
  const targetState = ancestors?.length ? {
    hierarchyPaths: ancestors,
    parentPath: ancestors[Math.max(0, ancestors.length - 2)],
  } : null;
  const routeLocation = redirect ? { ...location, pathname: target, state: targetState } : location;
  return <>
    {redirect && <Navigate to={target} state={targetState} replace />}
    {typeof children === 'function' ? children(routeLocation) : children}
  </>;
}
